import { CentralIconBase, type CentralIconBaseProps } from "./CentralIconBase";
import {
  centralIcons,
  centralIconsMetadata,
  type CentralIconName,
  type CentralIconStyle,
  type CentralIconImportName,
} from "./icons";
import { scopeSvgIds } from "./scopeSvgIds";
import React from "react";

export { type CentralIconBaseProps, type CentralIconStyle };

export type CentralIconProps = CentralIconBaseProps &
  CentralIconStyle & {
    name: CentralIconName;
  };

export const CentralIcon = React.memo(
  React.forwardRef<SVGSVGElement, CentralIconProps>(
    ({ name, join, fill, radius, stroke, children, ...props }, ref) => {
      // Avoid expanding the variant × icon-name cross product in TypeScript.
      const iconKey =
        `${join}-${fill}-radius-${radius}-stroke-${stroke}/${name as string}` as CentralIconImportName;
      const svg = centralIcons[iconKey];
      if (svg === undefined) {
        if (process.env.NODE_ENV !== "production") {
          console.warn(`[Central Icons] Unavailable icon variant: ${iconKey}`);
        }
        return null;
      }
      const maskId = `${join}-${fill}-radius-${radius}-stroke-${stroke}-${name}`;
      return (
        <CentralIconBase
          ariaLabel={centralIconsMetadata[name].title}
          {...props}
          ref={ref}
          maskId={maskId}
          renderShapes={(instanceId) => (
            <>
              {children}
              <g
                dangerouslySetInnerHTML={{
                  __html: scopeSvgIds(svg, instanceId),
                }}
              />
            </>
          )}
        />
      );
    },
  ),
);

CentralIcon.displayName = "CentralIcon";

export default CentralIcon;
